import { render } from "./BarcodeRangeInput.vue?vue&type=template&id=12f1641d"
import script from "./BarcodeRangeInput.vue?vue&type=script&lang=js"
export * from "./BarcodeRangeInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__